import { makeObservable, observable, runInAction } from "mobx";
import { getAppList, deleteApp, queryAppBaseInfo } from "utils/api";
import React from "react";
import { Dialog, Message } from "@jdcfe/legao";

export default class OverviewStore {
  applist = [{}];
  appListTableData = [];
  clientId = '';
  history = null;
  constructor() {
    makeObservable(this, {
      applist: observable,
      appListTableData: observable,
    });
  }
  //获取应用列表信息
  async getApplist(pageIndex, pageSize) {
    const res = await getAppList({
      pageIndex: pageIndex ? pageIndex : 1,
      pageSize: pageSize ? pageSize : 20,
      // xpin: "guoyaori1",
    });
    if (
      res.data.result &&
      (res.data.result.items !== undefined || res.data.result.items !== null)
    ) {
      runInAction(() => {
        this.applist = res.data.result.items;
        const appListArray = [];
        if (res.data.result.items && res.data.result.items.length !== 0) {
          res.data.result.items.forEach((item) => {
            const appListItem = {};
            appListItem.appName = item.appName;
            appListItem.appKey = item.appKey;
            appListItem.clientId = item.clientId
              ? item.clientId
              : "-";
            appListItem.handleAppInfo = (
              <div className="handel_status">
                {" "}
                <span
                  className="manage"
                  onClick={this.handletToManage.bind(this, item.appKey)}
                >
                  管理
                </span>{" "}
                {!item.clientId ? <span className="space">| </span> : ""}
                {!item.clientId ? (
                  <span
                    className="delete"
                    onClick={this.handleDelete.bind(
                      this,
                      item.appKey,
                      item.appName
                    )}
                  >
                    删除
                  </span>
                ) : (
                  ""
                )}
              </div>
            );
            appListItem.key = "listdata" + item.appKey;
            appListArray.push(appListItem);
            return appListArray;
          });
        }
        this.appListTableData = appListArray;
      });
    }
  }
  //获取单个应用的接口
  async queryAppBaseInfo(appKey) {
    const res = await queryAppBaseInfo({
      appKey: appKey,
    });
    if (res.data.success) {
      runInAction(() => {
        this.applist = [];
        this.applist.push(res.data.result);
        this.clientId = res.data.result.clientId
      });
    }
  }
  //接收函数
  getHistory = (history) => {
    this.history = history;
  };
  //管理
  handletToManage = (appKey) => {
    this.history.push(`/app/frame/overview?appKey=${appKey}`);
  };
  //删除应用
  handleDelete = (appKey, appName) => {
    const deleteHandle = Dialog.confirm({
      title: "删除应用",
      children: (
        <div className="delete_content">
          <div className="sure_tips">
            确定要删除应用<span>&quot;{appName}&quot;</span>吗？
          </div>
          <div className="warning_tips">
            删除后将无法通过此应用调用VOP接口，影响采购业务，请谨慎操作!
          </div>
        </div>
      ),
      wrapStyle: {
        zIndex: 99,
      },
      actions: [
        {
          text: "提交",
          onClick: () => {
            deleteHandle.close();
            this.suretoDelete(deleteHandle, appKey);
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => deleteHandle.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      type: "info",
      className: "delete_dialog",
    });
  };
  //确认删除
  suretoDelete = (deleteHandle, appKey) => {
    deleteApp({
      appKey: appKey,
    }).then((res) => {
      if (res.data.success) {
        Message.showMsg({
          showIcon: true,
          type: "success",
          description: "删除成功",
          autohide: true,
          closable: false,
          duration: 1000,
        });
        setTimeout(() => {
          this.getApplist().then(() => {
            deleteHandle.close();
          });
        }, 1000);
      }
    });
  };
}
